module.exports = __webpack_public_path__ + "assets/img/wx_01.a1009ee0.png";